<template>

    <div class="idea-card container">
        <div class="row">
            <div class="reviews">
                <div class="container idea-page">
                    <div class="row">
                        <div class="col-12 col-lg-2 back-remove">
                            <button @click="$router.go(-1)" class="button-back"><span>Назад</span></button>
                        </div>

                        <div class="col-12 col-lg-10">
                            <div class="remove-link"></div>
                            <h1 class="page-title">Редактирование идеи</h1>
                            <form class="form-plus-idea" @submit.prevent="saveIdea">
                                <input type="text"
                                       id="name"
                                       placeholder="Название идеи"
                                       class="style-input"
                                       v-model="idea.title"/>

                                <div class="help-blocks">
                                    <ul>
                                        <li class="help-block-title">Похожие темы</li>
                                        <li class="help-block-link"><a href="">Удаление аккаунта</a></li>
                                        <li class="help-block-link"><a href="">Удалить комментарий</a></li>
                                    </ul>
                                </div>

                                <select v-if="isAdmin" v-model="idea.status_id" class="arrow-select style-input">
                                    <option value="0">Отклонённая</option>
                                    <option value="1">На модерации</option>
                                    <option value="5">На голосовании</option>
                                    <option value="10">В работе</option>
                                    <option value="15">Реализована</option>
                                </select>

                                <div class="arrow-select">
                                    <div class="style-input turn" @click="showSelect = !showSelect" :class="{ active: showSelect, empty: !idea.category_id}">
                                        <span class="placeholer-element">{{categoryName}}</span>
                                        <span class="btton-push-cat"></span>
                                        <ul class="select-category" v-if="showSelect">
                                            <li v-for="cat in categories" @click.stop="chooseCategory(cat)">
                                                <span v-if="cat.parent_id"> &nbsp; &dash; </span>{{cat.title}}
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="arrow-select-bg" v-if="showSelect" @click="showSelect = false" />
                                </div>
                                <Editor placeholder="Описание"
                                        :content="idea.description"
                                        @change="setDescription"
                                        @ready="setDescription"
                                        @ctrl-enter="saveIdea"/>
                                <div class="form-footer">
                                    <button type="submit"
                                        class="button"
                                        :disabled="!formIsCorrect"
                                        v-tooltip="'привет'"
                                        :title=" formIsCorrect ? '' : 'Заполните, пожалуйста, все поля.' ">
                                        Сохранить идею
                                    </button>
                                    <em class="button-help" v-tooltip="'test'">
                                        Все поля обязательны к заполнению.
                                    </em>
                                </div>
                            </form>

                            <p class="form-info">
                                <span class="icon"></span> Все объявления проходят обязательно модерацию для проверки корректности вводимой информации
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>


</template>

<script>

    import Editor from './Editor'

    export default {
        name: 'idea-edit',

        components: {
            Editor
        },

        data() {
            return {
                id: null,
                showSelect: false,
                descriptionHtml: '',
                descriptionText: ''
            }
        },

        computed: {
            isAdmin() {
                return this.$store.getters['auth/isAdmin']
            },
            categoryName() {
                let cat = this.$store.getters['ideas/getCategoryTitle'](this.idea.category_id)
                return cat ? cat.title : 'Выберете категорию'
            },
            categories() {
                return this.$store.state.ideas.categories
            },
            formIsCorrect() {
                return this.idea.title && this.idea.category_id && this.idea.description
            },
            idea() {
                return this.$store.state.ideas.idea
            }
        },

        mounted() {
            this.$store.dispatch('ideas/setCurrentIdeaId', this.$route.params.id)
        },

        methods: {
            setDescription ({ html, text }) {
                this.descriptionHtml = html
                this.descriptionText = text
            },

            chooseCategory (cat) {
                if (cat)
                    this.idea.category_id = cat.id
                this.showSelect = false
            },

            saveIdea () {
                if (this.idea.title && this.descriptionText) {
                    let idea = Object.assign({}, this.idea, { description: this.descriptionHtml })
                    this.$http.post(`/api/ideas/${this.idea.id}/save`, idea)
                        .then((data) => {
                            this.$router.push({ name: 'idea', params: { id: this.idea.id }})
                        })
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// IdeaEdit.vue?485394e2